/* import __COLOCATED_TEMPLATE__ from './sh-invoice-line-items-list-item.hbs'; */
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { showModal } from "sh-www/utils/modal-controls";
import { SH_BILLABLE_LINE_ITEM } from "../../../../models/sh-billable-line-item";

/**
 * This is an individual list item withing a project line item list in the admin view
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: 'li',
  classNames: [
    'SH-c-sh-invoice-line-items-list-item',
    'LSG-l-grid',
    'padding-top-bottom-16px',
    'border-top-lsg-black'
  ],
  classNameBindings: [
    '_isOddIndex:background-lsg-xlight-gray',
    '_isOddIndex::background-lsg-white'
  ],

  /**
   * Register services
   */
  constants: service(),
  state: service('states/routes/admin/accounting/payin/sh-invoice'),
  stateManager: service('state-managers/routes/admin/accounting/payin/sh-invoice'),

  /*********************************
   * REQUIRED PARAMS
   *********************************/

  /**
   * @param {Number}
   */
  indexInTable: 0,

  /**
   * @param {ShInvoiceLineItem}
   */
  shInvoiceLineItem: null,

  /*********************************
   * OPTIONAL PARAMS
   **********************************/

  /*********************************
   * LIFECYCLE FUNCTIONS
   **********************************/

  /*********************************
   * PRIVATE
   **********************************/

  /**
   * @type {Boolean}
   */
  _isDeleteable: computed('shInvoiceLineItem.type', function() {
    return this.get('shInvoiceLineItem.type') === SH_BILLABLE_LINE_ITEM.TYPES.ADJUSTMENT;
  }),

  /**
   * @type {Boolean}
   */
  _isEditable: computed('shInvoiceLineItem.projectLineItem.id', function() {
    return this.get('shInvoiceLineItem.type') === SH_BILLABLE_LINE_ITEM.TYPES.ADJUSTMENT;
  }),

  /**
   * @type {Boolean}
   */
  _isOddIndex: computed('indexInTable', function() {
    return this.get('indexInTable') % 2 === 1;
  }),

  actions: {
    /**
     *
     */
    onDeleteLineItemClicked() {
      let modalModel = {
        titleText: 'Delete Line Item',
        bodyText: 'Are you sure you want to delete this line item?',
        actionButtonText: 'Okay',
        isShowCancelButton: true,
        confirmAction: () => {
          this.get('stateManager').deleteShInvoiceLineItem(this.get('shInvoiceLineItem'));
        }
      };

      showModal(this, 'confirmation', modalModel);
    },

    /**
     *
     */
    onEditProjectLineItemClicked: function() {
      const modalModel = {
        onAddLineItemAdded: () => {
          this.get('stateManager').lineItemEdited();
        },
        shInvoice: this.state.shInvoice,
        shInvoiceLineItem: this.shInvoiceLineItem,
      };

      showModal(this, 'admin/edit-sh-billable-line-item-modal', modalModel);
    }
  }
});
